import { render, staticRenderFns } from "./UrunTurBolgeAlisEkle.vue?vue&type=template&id=4ed94df4&scoped=true"
import script from "./UrunTurBolgeAlisEkle.vue?vue&type=script&lang=js"
export * from "./UrunTurBolgeAlisEkle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed94df4",
  null
  
)

export default component.exports